import { StaticLayout } from './static-layout'

export function DataProcessingPage() {
  return (
    <StaticLayout title="Data processing" description="How we handle your content.">
      <h2>Where data lives</h2>
      <p>
        All document data is stored on servers we control. We do not move it to third-party SaaS
        providers without making that explicit on this page.
      </p>
      <h2>Encryption</h2>
      <ul>
        <li>In transit: HTTPS/TLS for HTTP traffic and WSS for the real-time editor.</li>
        <li>At rest: standard disk-level encryption on the hosting platform.</li>
      </ul>
      <h2>Backups</h2>
      <p>
        We take regular backups of document content for disaster recovery only. Backups are
        retained for a short period and access is restricted.
      </p>
      <h2>Sub-processors</h2>
      <p>
        We use infrastructure providers for hosting and transactional email. They process data
        strictly under our instructions. The list is available on request via the{' '}
        <a href="/contact">contact page</a>.
      </p>
      <h2>Deletion</h2>
      <p>
        You can delete documents at any time from your dashboard. Account deletion (including all
        associated documents) is available on request.
      </p>
    </StaticLayout>
  )
}
